import gql from 'graphql-tag'

export default gql`
    mutation invalidateCurrentInsight($UserID: String!, $Domain: String!) {
        invalidateCurrentInsight(UserID: $UserID, Domain: $Domain)
    }
`
